var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      class: ["category-menu", { "-disabled": _vm.isFetching }],
      attrs: { "data-cy": "category-menu" }
    },
    _vm._l(_vm.categories, function(category) {
      return _c(
        "transition",
        { key: category.slug, attrs: { appear: "", name: "fade" } },
        [
          _c(
            "router-link",
            {
              class: ["link", { "-disabled": _vm.isFetching }],
              attrs: {
                "data-cy": "category-item",
                "active-class": "-active",
                "exact-active-class": "-active",
                exact: "",
                to: _vm._f("toLink")(category)
              },
              nativeOn: {
                click: function($event) {
                  return _vm.handleAnalytics(category)
                }
              }
            },
            [
              _c("k-icon", {
                staticClass: "icon",
                attrs: { icon: category.icon }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "name" }, [
                _vm._v(_vm._s(category.name))
              ])
            ],
            1
          )
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01005be4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01005be4","hasScoped":true,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Category/CategoryMenu.vue
// module id = 2143
// module chunks = 1610